import { useState, useEffect } from 'react'

function getVisibility() {
  if (typeof document === 'undefined') {
    return false
  }
  return document.visibilityState
}

export function useDocumentVisibility() {
  const [documentVisibility, setDocumentVisibility] = useState(getVisibility())

  function handleVisibilityChange() {
    setDocumentVisibility(getVisibility())
  }

  useEffect(() => {
    window.addEventListener('visibilitychange', handleVisibilityChange)
    return () => {
      window.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [])

  return documentVisibility
}
